import { Award, Flame, GraduationCap } from "lucide-react";
import { SubjectIcon } from "@/components/SubjectCard";

export const BadgeMedal = ({ badge, size = "md" }) => {
  const big = size === "lg";
  const isStreak = badge.kind === "streak";
  const ic = `${big ? "h-12 w-12" : "h-6 w-6"} text-white`;
  return (
    <div className={`relative flex items-center justify-center rounded-full bg-band ${big ? "h-40 w-40" : "h-20 w-20"}`}>
      <div className={`absolute inset-1.5 rounded-full border-2 border-dashed ${isStreak ? "border-orange-400/70" : "border-[var(--brand-cyan)]/70"}`} />
      <div className={`flex items-center justify-center rounded-full ${isStreak ? "bg-orange-500" : "bg-aqua-solid"} ${big ? "h-24 w-24" : "h-12 w-12"}`}>
        {isStreak ? <Flame className={ic} /> : badge.kind === "course" ? <GraduationCap className={ic} /> : badge.subject_id ? <SubjectIcon name={badge.icon} className={ic} /> : <Award className={ic} />}
      </div>
    </div>
  );
};
